<template>
  <div>
    <div class="personalInfo">

      <div class="card-right">

        <div class="info bill"  >
          <div class="card">
            <div class="card-top">
              <span></span>
              <h3>销售统计</h3>
            </div>

            <!--筛选条件-->
            <div class="card-form screen">

              <el-input
                  v-model="userName"
                  placeholder="请选择统计客户"
                  clearable
                  @focus="changeMember"
                  style="width: 200px;"
              ></el-input>
              <el-date-picker
                  style="width: 15%"
                  v-model="starttime"
                  type="date"
                  placeholder="统计开始日期"
                  format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd"
                  @input="queryReport"

              >
              </el-date-picker>

              <div>-</div>

              <el-date-picker
                  style="width: 15%"
                  v-model="endtime"
                  type="date"
                  placeholder="统计结束日期"
                  format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd"
                  @input="queryReport"
              >
              </el-date-picker>

              <el-form style="display: flex" key="0">
                <el-form-item>
                  <el-button type="primary" @click="queryReport">查询</el-button>
                  <el-button type="primary" @click="exportData2">导出</el-button>
                </el-form-item>
              </el-form>
            </div>

            <!--表格-->
            <div class="tops" >
              <p>收入合计：{{ receivableSumMoney }}元</p>
              <p>支出合计：{{ orderSumMoney }}元</p>
              <p>余额合计：{{ duePaymentSumMoney }}元</p>
            </div>
            <div >
              <el-table
                  key="200"
                  :data="tableData"
                  border
                  style="width: 95%;margin-left: 20px;"
              >
                <el-table-column prop="customerName" label="客户名称" align="left"  header-align="center"  width="300"/>

                <el-table-column  label="收入" align="center"   header-align="center"  width="350" >
                  <template slot-scope="scope">
                    <el-button type="text" @click="showDetail(scope.row,'2')">{{scope.row.amountReceived}}</el-button>
                  </template>
                </el-table-column>

                <el-table-column  label="支出" align="center"   header-align="center" width="300" >
                  <template slot-scope="scope">
                    <el-button type="text" @click="showDetail(scope.row,'1')">{{scope.row.orderFee}}</el-button>
                  </template>
                </el-table-column>

                <el-table-column prop="duePayment" label="余额" sortable align="center"  header-align="center" width="280">

                </el-table-column>


              </el-table>
            </div>
            <!--分页-->
            <div class="pages">
              <el-pagination
                  @size-change="handleSizeChange7"
                  @current-change="handleCurrentChange7"
                  :current-page="report.currentPage"
                  :page-sizes="[2, 5, 10, 15,50,100,200]"
                  :page-size="report.pageSize"
                  layout="total, sizes, prev, pager, next, jumper"
                  :total="report.total"
              >
              </el-pagination>
            </div>
          </div>
        </div>

      </div>
    </div>




    <el-dialog title="记账明细" :visible.sync="reportVisible" width="60%">
      <!--筛选条件-->
      <div class="card-form screen">
        <span class="span">客户名称:{{customerName}} <span style="margin-left: 40px;"> 查询时间:{{starttime}}~{{endtime}}</span> </span>  <el-button type="primary" style="margin-left: 40px;" @click="exportData1">导出</el-button>
     </div>

      <!--表格-->
      <div  style="  display: flex;justify-content: center;">
        <p style="color: #ff0000;  padding: 0 20px;" v-if="countType ==1 ">支出合计：{{ orderFeeMoney }}元</p>
        <p style="color: #ff0000;  padding: 0 20px;" v-if="countType ==2 ">收入合计：{{ receivedAllMoney  }}元</p>
      </div>
      <div >
        <el-table
            key="200"
            :data="tableData1"
            style="width: 100%"
        >
<!--          <el-table-column prop="orderId" label="订单号" width="150"/>-->
          <el-table-column prop="orderTime" label="操作时间" align="center"  header-align="center" width="150"/>
          <el-table-column prop="productName" label="摘要"   align="left"   header-align="center"  width="500" >
            <template slot-scope="scope">
               <span v-if="scope.row.quoteDesc ">{{scope.row.quoteDesc}} <br>
                        </span>
              <span v-if="scope.row.orderFee "> {{scope.row.payType}}：{{Number(scope.row.orderFee).toFixed(2)}}元
                        </span>
            </template>
          </el-table-column>
          <el-table-column prop="price" label="金额"   align="center"  header-align="center"  width="150"/>

<!--          <el-table-column prop="addMoney" label="存款" align="center"  width="120"/>-->
<!--          <el-table-column prop="subMoney" label="未结款" align="center"  width="120"/>-->
<!--          <el-table-column prop="userLastMoney" label="余额" align="center"  width="120"/>-->

        </el-table>
      </div>
      <!--分页-->
      <div class="pages">
        <el-pagination
            @size-change="handleSizeChange8"
            @current-change="handleCurrentChange8"
            :current-page="billForm.currentPage"
            :page-sizes="[2, 5, 10, 15]"
            :page-size="billForm.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
        >
        </el-pagination>
      </div>
    </el-dialog>


    <div class="dialogOther">
      <el-dialog
          title="选择客户"
          :visible.sync="showDialog"
          :close-on-click-modal="false"
      >
        <div class="queryMember">
          <el-row :gutter="10">
            <el-col :span="8">
              <el-input
                  v-model.trim="custName1"
                  placeholder="请输入用户名称"
              ></el-input
              ></el-col>
            <el-col :span="6">
              <el-button type="primary" @click="queryMemberDig(2)"
              >查询</el-button
              >
              <el-button @click="refMember(2)">刷新</el-button>
            </el-col>
          </el-row>
        </div>
        <el-table
            :data="allList"
            border
            style="width: 100%"
            class="memberTable"
        >
          <el-table-column header-align="center" align="center" width="30">
            <template scope="scope">
              <el-radio
                  :label="scope.row.user_ID"
                  v-model="radio1"
                  @change.native="getCurrentRow(scope.row)"
              ></el-radio>
            </template>
          </el-table-column>

          <el-table-column
              property="name"
              label="用户名称"
              header-align="center"
              align="center"
          >
          </el-table-column>
          <el-table-column
              label="联系方式"
              width="180"
              header-align="center"
              align="center"
          >
            <template slot-scope="scope">
              <span>{{
                  scope.row.phone ? scope.row.phone : scope.row.username
                }}</span>
            </template>
          </el-table-column>
          <el-table-column
              property="createTime"
              label="注册时间"
              width="200"
              header-align="center"
              align="center"
          >
          </el-table-column>
        </el-table>

        <div class="page">
          <el-pagination
              @size-change="handleSizeChange2"
              @current-change="handleCurrentChange2"
              :current-page="pageNumber2"
              :page-sizes="[5, 10, 20, 30]"
              :page-size="pageSize2"
              layout="total, sizes, prev, pager, next, jumper"
              :total="total"
          >
          </el-pagination>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="cancelChange">取 消</el-button>
          <el-button type="primary" @click="sureChange"
          >确 定</el-button
          >
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
// import pages from "../../components/pages/pagniation";
import { regionData, CodeToText } from "element-china-area-data";
import api from "../../api/invoice/invoice";
import { mapState } from "vuex";
import vueQr from "vue-qr";
import md5 from "js-md5";
import increaseInfo from "@/components/personal/increaseInfo";
import url from "../../api/picture";

export default {
  name: "salseReport",
  components: {
    vueQr,
    increaseInfo,
  },
  // components: {
  //   pages,
  // },
  data() {
    var validatePass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入密码"));
      } else {
        if (value.length > 6) {
          callback(new Error("输入密码格式为6位纯数字"));
          return;
        }
        if (this.ruleForm.checkPass !== "") {
          this.$refs.ruleForm.validateField("checkPass");
        }
        callback();
      }
    };
    var validatePass2 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请再次输入密码"));
      } else if (value !== this.ruleForm.pass) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };
    return {
      infoTime: "",
      increaseInfoId: "",
      dialogVisibleInrecerse: false,
      increaseList: [],
      increaseTotals: 0,
      // 发票列表
      increases: {
        pageSize: 10,
        currentPage: 1,
        extendColumn4: 0,
      },
      dialogFormVisible: false,
      payPop: false,
      orderFeeMoney: 0,
      orderSumMoney: 0,
      receivedAllMoney:0,
      duePaymentAllMoney:0,
      userAllLastSumMoney:0,
      orderPaySumMoney: 0,
      balanceSumMoney: 0,
      tableData1: [],
      html: "获取验证码",
      phone: "",
      disabled1: false,
      disabled: false, // 禁用input
      totals: 0,
      pages: {
        // 钱包明细
        pageSize: 10,
        currentPage: 1,
      },
      report: {
        pageSize: 50,
        currentPage: 1,
        total: 0,
      },
      reportVisible: false,
      totalMoney:0,
      gridData: [],
      payMoneyData: [],
      showDig: false,
      allMoney: 0, // 显示可用金额
      showPsBtn: false, // 展示提示按钮
      showText: 0, // 显示支付提示文本
      ruleForm: {
        // 支付密码设置
        pass: "",
        checkPass: "",
        verification: "",
      },
      rulepass: {
        pass: [{ validator: validatePass, trigger: "blur" }],
        checkPass: [{ validator: validatePass2, trigger: "blur" }],
        verification: [
          { required: true, message: "请输入验证码", trigger: "blur" },
        ],
      },
      img: "", // 二维码展示
      visible: false,
      options: regionData, //省市区三级联动数据
      // invoiceInfo: {},
      total: 0,
      billForm: {
        // 表格的
        currentPage: 1,
        pageSize: 10,
      },
      currentPage: 1,
      //开始时间
      starttime3: "",
      //结束时间
      endtime3: "",
      total3: 0,
      //未结款订单
      billForm3: {
        // 表格的
        currentPage: 1,
        pageSize: 10,
      },
      whetherFullPayment: 1,
      // 表格数据
      tableData3: [],
      //订单总金额
      allTotalMoney: "",

      checked: 0, // 切换模块
      userInfo: [
        {
          id: 0,
          text: "账户充值",
        },
        {
          id: 1,
          text: "支付密码",
        },
        {
          id: 2,
          text: "消费记录",
        },
        {
          id: 3,
          text: "未结款订单",
        },
        {
          id: 4,
          text: "发票资料",
        },

        // {
        //     id: 5,
        //     text: "我的优惠券",
        // },
      ],
      // 充值金额
      dynamicValidateForm: {
        recharge: "",
      },
      rules: {
        recharge: [
          { required: true, message: "请输入充值金额", trigger: "blur" },
        ],
      },

      //开始时间
      starttime: "",
      //结束时间
      endtime: "",
      //类型
      type: "",
      // 表格数据
      tableData: [],
      subSumMoney: 0,
      receivedSumMoney: 0,
      receivableSumMoney:0,
      duePaymentSumMoney:0,
      form: {
        increaseTicketNumber: "", // 发票税号
        increaseTicketBankNumber: "", //银行卡号
        unitName: "", // 单位名称
        increaseTicketBank: "", // 开户银行
        increaseTicketPhone: "", //注册电话
        increaseTicketAdress: "", //单位注册地
        recipientSName: "", // 开票人姓名
        recipientSPhone: "", // 开票人手机号
        address: "", // 详细地址
        increaseTicketType: "1", // 发票类型
        //开票抬头
        increaseTicketTitle: "",
        //开票类型
        extendColumn1: "2",
        recipientSAdress: "", //详细地址
        recipientSProvinceCode: "",
        recipientSProvinceZh: "",
        recipientSCityCode: "",
        recipientSCityZh: "",
        recipientSAreaCode: "",
        recipientSAreaZh: "",
        // //开票金额
        // invoicemoney: "",
        // //申请时间
        // date1: "",
      },
      rule: {
        increaseTicketType: [
          { required: true, message: "请选择发票类型", trigger: "blur" },
        ],
        extendColumn1: [
          { required: true, message: "请选择开票类型", trigger: "change" },
        ],
        increaseTicketTitle: [
          { required: true, message: "请输入开票抬头", trigger: "change" },
        ],
        unitName: [
          { required: true, message: "请输入单位名称", trigger: "blur" },
        ],
        increaseTicketNumber: [
          { required: true, message: "请输入发票税号", trigger: "blur" },
        ],
        increaseTicketAdress: [
          { required: true, message: "请输入注册地址", trigger: "blur" },
        ],
        increaseTicketPhone: [
          { required: true, message: "请输入注册电话", trigger: "blur" },
        ],
        increaseTicketBank: [
          { required: true, message: "请输入开户银行", trigger: "blur" },
        ],
        increaseTicketBankNumber: [
          { required: true, message: "请输入银行账号", trigger: "blur" },
        ],
        // recipientSName: [
        //   { required: true, message: "请输入收票人姓名", trigger: "change" },
        // ],
        // recipientSPhone: [
        //   { required: true, message: "请输入收票人电话", trigger: "change" },
        // ],
        // address: [
        //   { required: true, message: "请选择收票地址", trigger: "change" },
        // ],
        // recipientSAdress: [
        //   { required: true, message: "请输入详细地址", trigger: "change" },
        // ],
      },
      pageNumber2: 1,
      pageSize2: 5,
      custName1: "",
      showDialog: false,
      allList: [], // 客户列表
      showInfo: false, // 展示发票类型相关数据
      showBtn: true, // 展示修改删除按钮
      invoiceId: "", // 发票id
      rechargeFrom: {
        ordeRnumber: "",
        type: "",
        userId: "",
      },
      userName: '',
      userId: "", // 当前登录者的user_ID
      customerId: '',
      isInvoice:'2',
      userBan: {},
      pageSize: 10,
      pageNumber: 1,
      extendColumn2: "",
      reCode: "", // 获取的验证码
      reciordList: [], //消费详情
      userType: "",
      // 支付相关
      newPwdReadOnly: false,
      input: "",
      orderPay: 0, // 订单实付金额
      orderMoney: 0, //(实际订单金额)
      credit: 0, //信用额度
      wallet: 0, // 钱包余额
      radio1: "4",
      customerName: "", //客户名称
      countType: "", // 统计类型
      orderInfo: {}, // 订单详情
      checkList: [], // 复选框
      changeType: "0", // 是否余额抵扣(0:否，1是)
      imgs: "", // 二维码图片
      showPayType: false, //展示支付方式
      showText1: "", //展示文本
      payInfo: {
        // 支付参数
        orderId: "",
        userId: "",
        userfatherid: "",
        paymentProportion: "",
        haveOtherPayment: "",
        paymentChooses: "",
        haveOtherPaymentChooses: "",
      },
      paySuccess: false, // 微信、支付宝 支付成功
      payLoading: false,
      showSuer: false, // 支付按钮
      disabled5: false, // 余额
      disabled6: false, // 其他
      payPass: false, // 支付密码是否校验成功
      checks: false, //有支付密码
      threePay: false, //余额加信用不足
      rechargeFromB: {
        ordeRnumber: "",
        type: "",
        userId: "",
      },
      mallBankInfo: {}
    };
  },
  computed: {
    ...mapState(["currentInfo"]),
  },
  filters: {
    numbers(value) {
      let relval = 0;
      if (!isNaN(value) && value !== "") {
        relval = parseFloat(value).toFixed(0);
      } else {
        relval = 0;
      }
      return relval;
    },
  },
  watch: {
    "form.extendColumn1": function (v) {
      console.log("当前开票类型", v);
      if (v === "1") {
        this.rule = {
          increaseTicketType: [
            { required: true, message: "请选择发票类型", trigger: "blur" },
          ],
          extendColumn1: [
            { required: true, message: "请选择开票类型", trigger: "change" },
          ],
          increaseTicketTitle: [
            { required: true, message: "请输入开票抬头", trigger: "change" },
          ],
          recipientSName: [
            { required: true, message: "请输入收票人姓名", trigger: "change" },
          ],
          recipientSPhone: [
            { required: true, message: "请输入收票人电话", trigger: "change" },
          ],
          address: [
            { required: true, message: "请选择收票地址", trigger: "change" },
          ],
          recipientSAdress: [
            { required: true, message: "请输入详细地址", trigger: "change" },
          ],
        };
      }
    },
    "form.increaseTicketType": function (v) {
      console.log("当前发票类型", v);
      if (v) {
        // this.showInfo = false; // 隐藏个人选项
        this.rule = {
          increaseTicketType: [
            { required: true, message: "请选择发票类型", trigger: "blur" },
          ],
          extendColumn1: [
            { required: true, message: "请选择开票类型", trigger: "change" },
          ],
          increaseTicketTitle: [
            { required: true, message: "请输入开票抬头", trigger: "change" },
          ],
          unitName: [
            { required: true, message: "请输入单位名称", trigger: "blur" },
          ],
          increaseTicketNumber: [
            { required: true, message: "请输入发票税号", trigger: "blur" },
          ],
          increaseTicketAdress: [
            { required: true, message: "请输入注册地址", trigger: "blur" },
          ],
          increaseTicketPhone: [
            { required: true, message: "请输入注册电话", trigger: "blur" },
          ],
          increaseTicketBank: [
            { required: true, message: "请输入开户银行", trigger: "blur" },
          ],
          increaseTicketBankNumber: [
            { required: true, message: "请输入银行账号", trigger: "blur" },
          ],
        };
      }
    },
    checkList(v) {
      console.log("复选框变化", v);
      if (v.length > 0) {
        let other = v.some((el) => el === "2"); //其他：微信、支付宝
        let pay = v.some((el) => el === "3"); // 信用（暂时不起用）
        let balance = v.some((el) => el === "1"); //余额
        console.log("存在其他", other);
        if (other && v.length > 1) {
          // 存在混合
          this.imgs = "";
          this.showText1 = 0;
          this.showSuer = false;
        }
        if (balance) {
          // 余额
          if (this.wallet >= this.orderPay) {
            //余额充足
            this.disabled6 = true; //其他禁用
            let index = v.findIndex((el) => el === "2");
            console.log("获取下标", index);
            if (index !== -1) {
              this.checkList.splice(index, 1);
            }
            if (!this.payPass) {
              this.showSuer = true;
            }
            if (this.userType !== 0) {
              // 代客支付 不需要支付验证
              this.changeType = "0";
              this.showSuer = false;
            }
          } else {
            //余额不足
            if (v.length === 1) {
              this.$message.warning("当前余额不足,请配合其他方式支付！");
              this.showSuer = true;
            }
            this.disabled6 = false;
          }
          // if (this.credit <= 0) { // 信用
          //   this.disabled3 = true;
          // }
        }

        if (pay || balance) {
          if (this.userType !== 0) {
            // 代客支付 不需要支付验证
            this.changeType = "0";
          } else {
            this.changeType = "1";
          }
        } else {
          this.changeType = "0";
        }
        if (other) {
          // 微信，支付宝
          this.showPayType = true;
          if (this.changeType === "1") {
            // 存在余额
            if (this.payPass) {
              // 支付密码正确
              this.showSuer = false;
            }
          } else {
            this.showSuer = false;
          }
        } else {
          this.showPayType = false; //隐藏付款方式
          this.imgs = "";
          this.showText1 = "";
        }
      } else {
        // if (this.radio && this.radio !== "3") {
        //   this.disabled1 = this.disabled2 = this.disabled3 = false;
        // }
        console.log("复选框为0", this.wallet);
        if (this.wallet <= 0) {
          console.log("执行了这里", this.wallet);
          //余额不足
          this.disabled5 = true;
        }
        // if (this.credit <= 0) { // 信用
        //   this.disabled3 = true;
        // }
        // if (this.radio1 !== "3" && this.radio1 !== "0") {
        //   console.log("执行了这里");
        //   this.disabled6 = false;
        //   this.showSuer = true;
        // }
        this.disabled6 = false;
        this.showSuer = true;
        this.showPayType = false; //隐藏付款方式
        this.imgs = "";
        this.showText1 = "";
        this.changeType = "0";
      }
    },
    changeType(v) {
      console.log("changeType", v);
      if (v === "1") {
        this.checks = true;
        if (this.payPass) {
          this.showSuer = true;
        }
      } else {
        this.checks = false;
      }
    },
    input(v) {
      if (this.changeType === "1") {
        if (v === "") {
          this.newPwdReadOnly = true;
          this.newPwdFocus(null);
        }
      }
    },
  },
  created() {
    let obj = JSON.parse(window.sessionStorage.getItem("currentInfo"));
    this.isInvoice   = window.sessionStorage.getItem("customer")? JSON.parse(window.sessionStorage.getItem("customer")).isInvoice:'2';
    if (obj === null) return;

    this.userType = obj.userType;
    console.log("userType", this.userType);
    this.getCurrentMonthFirst();
    this.getCurrentDay();
    this.queryReport()

  },
  mounted() {},
  updated() {
  },
  methods: {

    getCurrentMonthFirst() {
      var date1 = new Date()
      date1.setDate(1)
      date1.setMonth(parseInt(date1.getMonth())-1)
      var date2 = new Date(date1)
      var year = date2.getFullYear()
      var month = date2.getMonth()+1
      var day = date2.getDate()
      month = (month > 9) ? month : ('0' + month)
      day = (day < 10) ? ('0' + day) : day
      this.starttime = year + '-' + month + '-' + day
    },
    getCurrentDay() {
      var date = new Date()
      var year = date.getFullYear()
      var month = date.getMonth() + 1
      var day = date.getDate()
      month = (month > 9) ? month : ('0' + month)
      day = (day < 10) ? ('0' + day) : day
      this.endtime = year + '-' + month + '-' + day
    },




    cancelChange() {
      this.userName ='';
      this.userId = ''
      this.showDialog = false;
    },
    sureChange() {
      if (this.radio1 === "") {
        this.$message.warning("请选择客户！");
        return;
      }
      this.queryReport();
      this.getCustomer();
      this.showDialog = false;
    },






    wacthChange(value) {
      if (value.length === 6) {
        this.$refs.inputPs.blur();
      }
    },
    // 选择客户（单选）
    getCurrentRow(item) {
        this.userName = item.name;
        this.userId = item.user_ID

    },
    //筛选客户条件分页
    handleSizeChange2(val) {
      this.pageSize2 = val;
      this.getCustomer();
    },
    handleCurrentChange2(val) {
      this.pageNumber2 = val;
      this.getCustomer();
    },
    changeMember() {
      this.showDialog = true;
      this.radio1 = "";
      this.getCustomer();
    },
    // 新增客户弹框查询
    queryMemberDig(type) {
      if (type === 1) {
        this.radio = "";
      } else {
        this.radio1 = "";
      }
      this.getCustomer();
    },
    // 新增客户弹框刷新
    refMember(type) {
      // 新增客户查询
      if (type === 1) {
        this.pageNumber = 1;
        this.pageSize = 5;
        this.custName = this.radio = this.form.name = "";
      } else {
        // 列表客户查询
        this.pageNumber2 = 1;
        this.pageSize2 = 5;
        this.custName1 = this.radio1 = "";
      }
      this.getCustomer();
    },
    getCustomer() {

      api
          .queryUser1(
              this.pageNumber2,
              this.pageSize2,
              "",
              "",
              this.custName1,
              "0"
          )
          .then((res) => {
            console.log("获取客户", res);
            if (res.success) {
              // this.allList = res.data.userPageInfo.list;
              this.allList = res.data.list;
              this.total = res.data.total;

            } else {
              this.$message.error(res.message);
            }
          });
    },


    // 获取用户详情
    getUserInfos(id) {
      api
        .getUserMoneyAndCredits(1, id)
        .then((res) => {
          // console.log("获取用户详情", res);
          if (res.success) {
            this.credit = Number(res.data.credits); //信用额度
            this.wallet = Number(res.data.balance); // 钱包余额
            this.customerName = res.data.user.name;
            if (this.wallet <= 0) {
              this.disabled5 = true;
            } else {
              this.disabled5 = false;
            }
          } else {
            this.$message.error(res.message);
          }
        })
        .catch((error) => {
          console.error("error", error);
        });
    },


    // 获取消费记录
    getPayList() {
      api
        .consumerCenter(
          this.starttime,
          this.endtime,
          this.billForm.pageSize,
          this.billForm.currentPage,
         2,
            this.userId
        )
        .then((res) => {
          console.log("消费记录", res);
          if (res.success) {
            this.orderFeeMoney =  Number(res.data.orderFeeMoney).toFixed(2);
            this.receivedAllMoney = Number(res.data.receivedAllMoney).toFixed(2);
            this.tableData = res.data.useWalletPageInfo.list;
            this.total = res.data.useWalletPageInfo.total;
          }
        });
    },
    getPayList1() {
      api
          .consumerCenterNew(
              this.starttime,
              this.endtime,
              this.billForm.pageSize,
              this.billForm.currentPage,
              '',
              this.customerId,
              this.countType
          )
          .then((res) => {
            console.log("消费记录", res);
            if (res.success) {
              this.orderFeeMoney =  Number(res.data.orderFeeMoney).toFixed(2);
              this.receivedAllMoney = Number(res.data.receivedAllMoney).toFixed(2);
              this.duePaymentAllMoney = Number(res.data.duePaymentAllMoney).toFixed(2);
              this.tableData1 = res.data.useWalletPageInfo.list;
              this.total = res.data.useWalletPageInfo.total;
            }
          });
    },

    // 获取用户详情
    getUserInfo() {
      api
        .getUserMoneyAndCredits(2, null)
        .then((res) => {
          console.log("获取用户详情", res);
          if (res.success) {
            this.allMoney = res.data.balance;
          } else {
            if (this.userType === 0) {
              this.$message.error(res.message);
            }
          }
        })
        .catch((error) => {
          console.error("error", error);
        });
    },


    handleSizeChange1(val) {
      this.pages.pageSize = val;
      this.showDigs();
    },
    handleCurrentChange1(val) {
      this.pages.currentPage = val;
      this.showDigs();
    },


    queryReport(){
      if(this.userName ===''||this.userName === undefined){
        this.userId = '';
      }
      this.getReportList();
    },
    showDetail(item,type){
      this.customerId = item.userId;
      this.customerName = item.customerName;
      this.countType = type;
      this.query1();
      this.reportVisible = true;
    },
    getReportList() {
      api
          .queryCustomerReportNew(
              this.starttime,
              this.endtime,
              this.report.pageSize,
              this.report.currentPage,
              this.userId
          )
          .then((res) => {
            console.log("消费记录", res);
            if (res.success) {
              this.orderSumMoney =  Number(res.data.orderSumMoney).toFixed(2);
              this.receivableSumMoney = Number(res.data.receivableSumMoney).toFixed(2);
              this.duePaymentSumMoney = Number(res.data.duePaymentSumMoney).toFixed(2);
              this.tableData = res.data.list;
              this.report.total = res.data.total;
            }
          });
    },

    handleSizeChange8(val) {
      this.billForm.pageSize = val;
      this.getPayList1();
    },
    handleCurrentChange8(val) {
      this.billForm.currentPage = val;
      this.getPayList1();
    },
    handleSizeChange7(val) {
      this.report.pageSize = val;
      this.getReportList();
    },
    handleCurrentChange7(val) {
      this.report.currentPage = val;
      this.getReportList();
    },





    query1(){
       this.getPayList1();
    },



    exportData1(){
      if(this.countType ==1){
        window.location.href = url.baseUrl + '/usewallet/queryConsume/exportCustomerConsumptionRecords/new1?startTime=' + this.starttime + '&endTime='+this.endtime+'&userId='+this.customerId +'&countType='+this.countType;

      }else {
        window.location.href = url.baseUrl + '/usewallet/queryConsume/exportCustomerConsumptionRecords/new?startTime=' + this.starttime + '&endTime='+this.endtime+'&userId='+this.customerId +'&countType='+this.countType;

      }
    },
    exportData2(){
      window.location.href = url.baseUrl + '/usewallet/customerSalesReport/exportDataNew?startTime=' + this.starttime + '&endTime='+this.endtime+'&userId='+this.userId;

    },

    exportData(){

      window.location.href = url.baseUrl + '/usewallet/queryConsume/exportCustomerConsumptionRecords?startTime=' + this.starttime + '&endTime='+this.endtime;

    },

  },
};
</script>

<style lang="scss" scoped>
.payContent {
  /*text-align: center;*/

  .orderInfos {
    margin: 10px 0;
  }

  .top {
    margin: 10px 0;

    .check-group {
      display: flex;
      flex-direction: column;
      line-height: 30px;
    }
  }

  .ipt {
    height: 40px;
    line-height: 40px;
    display: flex;
    margin: 15px 0px;

    .inputs {
      width: 200px;
    }
  }

  .payTypes {
    /*付款平台*/
    .pingtai {
      overflow: hidden;
      margin-left: 125px;

      ul li {
        float: left;
        display: inline;
        position: relative;
        width: 177px;
        height: 50px;
        cursor: pointer;
        border: 1px solid #d2d1d1;
        margin-right: 18px;
        /*微信支付*/
        .wx {
          background: url(../../static/imgs/sprites-payment-logo.png) no-repeat;
          background-position: 0 -1880px;
          display: inline-block;
          width: 175px;
          height: 37px;
          vertical-align: middle;
          position: absolute;
          top: 7px;
          *top: 5px;
          left: 1px;
          z-index: 2;
        }

        /*支付宝支付*/
        .zfb {
          background: url(../../static/imgs/sprites-payment-logo.png) no-repeat;
          background-position: 0 -120px;
          display: inline-block;
          width: 175px;
          height: 37px;
          vertical-align: middle;
          position: absolute;
          top: 7px;
          *top: 5px;
          left: 1px;
          z-index: 2;
        }
      }
    }

    .imgs {
      display: flex;
      justify-content: center;
    }

    p {
      text-align: center;
      color: #ff0000;
    }
  }

  .successBtn {
    margin-top: 15px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}

.btns {
  margin-left: 10px;
}

.personalInfo {
  padding: 20px 0;
  width: 100%;
  display: flex;
  justify-content: space-between;

  .card-left {
    width: 200px;
    height: 360px;

    .top {
      width: 100%;
      height: 86px;
      line-height: 86px;
      text-align: center;
      background-color: #047bd7;
      color: #fff;
      font-size: 24px;

      i {
        font-size: 28px;
        margin-right: 10px;
      }
    }

    .infos {
      width: 100%;
      box-sizing: border-box;
      // border: 1px solid #e6e6e6;
      // border-top: none;
      li {
        box-sizing: border-box;
        width: 100%;
        height: 55px;
        text-align: center;
        line-height: 55px;
        border-bottom: 1px dashed #e6e6e6;
        cursor: pointer;
      }

      li:last-child {
        border-bottom: none;
      }

      .checked {
        background-color: #058af2;
        color: #fff;
        font-weight: 600;
      }
    }
  }

  .card-right {
    width: 1500px;
    background-color: #fff;
  }

  .tops {
    display: flex;
    justify-content: center;
    margin-left:  -485px;

    p {
      font-size: 24px;
      color: #ff0000;
      padding: 0 20px;
    }
  }

  .info {
    width: 100%;
    box-sizing: border-box;
    // padding: 15px;
  }

  .card {
    width: 100%;

    .card-top {
      display: flex;
      align-items: center;
      height: 50px;
      border-bottom: 1px solid #e6e6e6;
      padding: 0 30px;
      line-height: 50px;

      span {
        display: inline-block;
        width: 5px;
        height: 17px;
        background: #058af2;
        margin-right: 20px;
      }

      h3 {
        width: 70%;
        color: #058af2;
      }

      .fapiao {
        width: 300px;
        color: #058af2;
      }

      .infos {
        width: 150px;
        margin-left: 20px;
        color: #047bd7;
        cursor: pointer;
      }
    }

    .table {
      margin: 15px;

      .del {
        color: #ff0000;
      }
    }

    .list {
      width: 100%;
      box-sizing: border-box;
      padding: 5px 30px;

      .list-top {
        display: flex;
        justify-content: space-between;

        span {
          color: #058af2;
        }

        span:last-child:hover {
          cursor: pointer;
          text-decoration: underline;
        }
      }

      .list-item {
        width: 100%;
        margin-top: 10px;
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;

        .items {
          margin-top: 10px;
          width: 255px;
          height: 155px;
          background: transparent url("../../static/imgs/beijing1.png")
            no-repeat scroll 0% 0%;
          position: relative;

          .border {
            box-sizing: border-box;
            padding: 15px;
            font-size: 14px;
            font-weight: 400;

            p {
              padding: 3px 0 5px 0;

              border-bottom: 1px solid #e6e6e6;
            }

            i {
              display: inline-block;
              margin-right: 10px;
            }

            p:nth-child(2) {
              height: 65px;
              display: flex;
              align-items: center;

              span {
                display: block;
                overflow: hidden;
                white-space: normal;
                text-overflow: ellipsis;
              }
            }

            p:last-child {
              border-bottom: none;
            }
          }

          .top {
            position: absolute;
            top: 0;
            right: 15px;
            font-size: 14px;
            height: 20px;
            line-height: 20px;
            color: #fff;

            .top-df {
              display: none;
              background: #fbb244 none repeat scroll 0% 0%;
              padding: 0px 10px;
              border-radius: 0px 0px 5px 5px;
            }
          }

          .active {
            display: block;
            padding: 0 10px;
            background: #058af2 none repeat scroll 0% 0%;
          }

          .top:hover {
            cursor: pointer;
            text-decoration: underline;
          }

          .bottom {
            display: none;
            position: absolute;
            right: 20px;
            bottom: 8px;
            cursor: pointer;
            font-size: 14px;

            p {
              float: left;
              border: 1px solid #d4d4d4;
              margin-left: 5px;
              height: 25px;
              line-height: 25px;
              width: 40px;
              text-align: center;
              border-radius: 3px;
              background-color: #fff;
            }

            p:hover {
              color: #058af2;
            }
          }
        }

        .items-bgd {
          background: transparent url("../../static/imgs/beijing2.png")
            no-repeat scroll 0% 0%;
        }

        .items:hover .top-df {
          display: block;
        }

        .items:hover .bottom {
          display: block;
        }

        .items:nth-last-child(-n + 1) {
          height: 0;
          background: none;
        }
      }
    }
  }

  /*账户充值*/
  .recharge {
    .card-form {
      width: 50%;
      margin: 30px auto;
      /*账户充值_金额数目*/
      .money {
        color: red;
        padding: 0 5px;
        font-weight: bold;
      }
    }

    /*付款方式*/
    .payment {
      width: 95%;
      border-top: 1px dashed #e6e6e6;

      .text {
        font-size: 14px;
        width: 50%;
        margin: 20px auto 20px;
      }

      /*付款平台*/
      .pingtai {
        width: 50%;
        overflow: hidden;
        margin: 20px auto 20px;
        display: flex;
        justify-content: center;
        align-items: center;

        ul li {
          float: left;
          display: inline;
          position: relative;
          width: 177px;
          height: 50px;
          cursor: pointer;
          border: 1px solid #d2d1d1;
          margin-right: 18px;
          /*微信支付*/
          .wx {
            background: url(../../static/imgs/sprites-payment-logo.png)
              no-repeat;
            background-position: 0 -1880px;
            display: inline-block;
            width: 175px;
            height: 37px;
            vertical-align: middle;
            position: absolute;
            top: 7px;
            *top: 5px;
            left: 1px;
            z-index: 2;
          }

          /*支付宝支付*/
          .zfb {
            background: url(../../static/imgs/sprites-payment-logo.png)
              no-repeat;
            background-position: 0 -120px;
            display: inline-block;
            width: 175px;
            height: 37px;
            vertical-align: middle;
            position: absolute;
            top: 7px;
            *top: 5px;
            left: 1px;
            z-index: 2;
          }
        }
      }
    }

    .img {
      margin-right: 90px;
      display: flex;
      justify-content: center;
    }

    .btns {
      padding: 15px;
      display: flex;
      justify-content: center;
      align-items: center;

      i {
        color: #fbb244;
        font-size: 14px;
      }
    }

    p {
      text-align: center;
      color: #ff0000;
      margin-right: 90px;
    }
  }

  /*我的账单*/
  .bill {
    /*筛选条件*/
    .card-form {
      display: flex;
      line-height: 40px;
      margin: 20px auto;
      margin-right: 20px;
      margin-left: 30px;
      .el-form-item {
        margin-bottom: 0px;
      }

      .el-form-item__label {
        font-size: 16px !important;
      }

      label {
        font-size: 16px !important;
      }

      div {
        margin: auto 5px;
      }
    }

    /*表格*/
    .table {
      margin-right: 0;
      border-top: 1px dashed #e6e6e6;
    }

    /*分页*/
    .pages {
      display: flex;
      margin: 20px 20px;
      justify-content: space-between;
    }
  }
}

.demo-ruleForm {
  ::v-deep .el-input {
    width: 100%;
  }
}

.orderInfo {
  display: flex;
}

// .el-form-item__content {
//   display: flex;
// }
.footer {
  float: right;
  margin-left: 10px;
}
/* 强制单元格左对齐 */
.el-table .cell {
  text-align: left !important;
}

/* 强制表头居中 */
.el-table thead .cell {
  text-align: center !important;
}
</style>

<style lang="scss">
 

.invoice {
  .el-row {
    text-align: center;
    margin: 50px 0;
  }
}

.invoice {
  .el-form {
    margin: 30px;
  }
}

.page {
  margin: 15px;
}
</style>
